import { NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '@environments/environment';
import { HlFooterComponent } from '@layout/hl-footer/hl-footer.component';
import { HlStepsComponent } from '@layout/hl-steps/hl-steps.component';
import { RestrictedNavigationService } from '@services/restricted-navigation.service';

@Component({
  selector: 'app-healthlabs-layout',
  templateUrl: './healthlabs-layout.component.html',
  styleUrls: ['./healthlabs-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, HlStepsComponent, HlFooterComponent, NgOptimizedImage],
})
export class HealthlabsLayoutComponent implements OnInit {
  public restrictedNavigation: boolean = false;

  protected restrictedNavigationService = inject(RestrictedNavigationService);

  /**
   * Return the phone number formatted for tel href.
   */
  public get formattedPhoneNumber(): string {
    return environment.phone.replace(/[^0-9]/g, '');
  }

  /**
   * Returns the brand's customer service phone number.
   */
  public get phoneNumber(): string {
    return environment.phone;
  }

  public ngOnInit(): void {
    this.restrictedNavigationService.restrictedNavigationObserver.subscribe((r) => (this.restrictedNavigation = r));
  }
}
